import { makeObservable } from 'mobx';
import { ContactInfoStore } from './contact-info';
import { DesiredPositionStore } from './desired-position';

export class CreateResumeStore {
    constructor(
        public readonly contactInfoStore: ContactInfoStore,
        public readonly desiredPosition: DesiredPositionStore
    ) {
        makeObservable(this);
    }
}
